import axios from 'axios';

let baseUrl = "http://api.patrimonio.site";

if(document.domain == 'sigepa.gobbots.com'){
    baseUrl = "https://sigepa.api.gobbots.com";
}

if(document.domain == 'sigepa.ameca.mx'){
    baseUrl = "https://sigepa.api.gobbots.com";
}

if(document.domain == 'sigepa.ameca.gob.mx'){
    baseUrl = "https://sigepa.api.gobbots.com";
}

axios.defaults.baseURL = baseUrl;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'Application/json';

if (localStorage.getItem('domain') === null || localStorage.getItem('domain') === 'undefined') {
    axios.defaults.headers.common['domain'] = 'demo';
} else {
    axios.defaults.headers.common['domain'] = localStorage.getItem('domain');
}

if (localStorage.getItem('token') === null || localStorage.getItem('token') === 'undefined') {
    axios.defaults.headers.common['api-token'] = '';
} else {
    axios.defaults.headers.common['api-token'] = localStorage.getItem('token');
}

axios.interceptors.request.use(function (config) { 
    return config;
}, function (error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    if(error.response !== undefined){
        if (error.response.status === 401) {
            console.log(error.response);
        } else if (error.response.status === 500 || error.response.status === 404 || error.response.status === 400) {
            throw error;
        } else {
            return Promise.reject(error);
        }
    }
    else{
        return Promise.reject(error);
    }
})
